/* jshint esversion: 6 */
/* jshint esversion: 11 */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { TbMapPinFilled } from 'react-icons/tb';
import Slider from "react-slick";
import { IoCheckmarkCircle, IoChevronBackOutline, IoCloseSharp } from 'react-icons/io5';
import { showToast } from '../../showTost';
import { MdOutlineArrowCircleRight } from "react-icons/md";
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import Chat from './Chat';
import { useLocation } from 'react-router-dom';
import test_tube from "../../assets/Icon/test_tube.svg";
import capsule from "../..//assets/Icon/capsule.svg";
import Hospital from "../../assets/Icon/hospital.svg";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
import MapPin from "../../assets/Icon/mappin.svg";
const BookingDetails = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, mapKey } = useContext(MyContext);

    const Location = useLocation();
    const Data = Location.state;

    const [doctorData, setDoctorData] = useState();
    const [sebserviceData, setSebserviceData] = useState();
    const [appointData, setAppointData] = useState();
    const [time, setTime] = useState({ hours: "", minutes: "", seconds: "" });
    const [familyData, setFamilyData] = useState([]);
    const [isPatientBox, setIsPatientBox] = useState();
    const [addDocument, setAddDocument] = useState([]);
    const [getDocument, setGetDocument] = useState([]);
    const [healthConcern, setHealthConcern] = useState();
    const [hospitalData, setHospitalData] = useState();
    const [isShowDownload, setIsShowDownload] = useState(true);
    const [selectPatient, setSelectPatient] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [vitalaInfoData, setVitalaInfoData] = useState([]);
    const [deviceCheck, setDeviceCheck] = useState(false);
    const [drugsInfoData, setDrugsInfoData] = useState([]);
    const [diagnosisData, setDiagnosisData] = useState([]);
    const [medicineDetails, setMedicineDetails] = useState();
    const [cancelReasonList, setCancelReasonList] = useState([]);
    const [isCancelBox, setIsCancelBox] = useState(false);
    const [selectReason, setSelectReason] = useState();
    const [otherReason, setOtherReason] = useState();
    const [loading, setLoading] = useState(true);
    const [showChat, setShowChat] = useState(false);
    const [selectDoc, setSelectDoc] = useState("");
    const [isReview, setIsReview] = useState(false);
    const [reviewIndex, setReviewIndex] = useState(1);
    const [reviewText, setReviewText] = useState();
    const [checkList, setCheckList] = useState();
    const [prescriptionload, setPrescriptionLod] = useState("");
    const [notificationlod, setNotificationLod] = useState(false);
    const [token, setToken] = useState("");

    const InputRef = useRef();
    const InputRef2 = useRef();

    const Userid = secureLocalStorage.getItem("Userid");


    const settings = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            { breakpoint: 1205, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 330, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        ],
    };

    const settings2 = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            { breakpoint: 770, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        ],
    };

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: mapKey
    });

    useEffect(() => {
        HandleFatchData();
    }, []);

    const HandleFatchData = () => {
        const AppointmentId = sessionStorage.getItem("Appintmentid");
        if (AppointmentId && Userid) {
            axios.post(`${ApiBaseUrl}/customer/appointment_detail`, { id: Userid, appointment_id: AppointmentId })
                .then((res) => {
                    console.log("appointment_detail", res);
                    const { doctor, sebservice, appoint, family_member, hospital, ResponseCode, token_position } = res.data;
                    if (ResponseCode === 200) {
                        setLoading(false);
                        setDoctorData(doctor);
                        setSebserviceData(sebservice);
                        setAppointData(appoint);
                        convertTime(appoint.timecount);
                        setFamilyData(family_member);
                        setSelectPatient(family_member[0]?.id);
                        setHospitalData(hospital);
                        setToken(token_position);
                        const { vitals_physical, drugs_prescription, diagnosis_test } = appoint;
                        setCheckList({ vitals_physical, drugs_prescription, diagnosis_test });
                        if (vitals_physical !== 0 || drugs_prescription !== 0 || diagnosis_test !== 0) {
                            setIsShowDownload(false);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

            axios.get(`${ApiBaseUrl}/customer/appint_cancel_list`)
                .then((res) => {
                    // console.log("appint_cancel_list", res);
                    setCancelReasonList(res.data.cancel_reason);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const convertTime = (time) => {
        const totalSeconds = parseInt(time, 10);

        let hours = Math.floor(totalSeconds / 3600);
        const remainingSecondsAfterHours = totalSeconds % 3600;
        let minutes = Math.floor(remainingSecondsAfterHours / 60);
        let seconds = remainingSecondsAfterHours % 60;

        setTime({ hours, minutes, seconds });
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(prevTime => {
                let { hours, minutes, seconds } = prevTime;

                if (hours === 0 && minutes === 0 && seconds === 0) {
                    clearInterval(timer);
                    return prevTime;
                }

                if (seconds === 0) {
                    if (minutes === 0) {
                        if (hours === 0) {
                            return { hours: 0, minutes: 0, seconds: 0 };
                        }
                        return { hours: hours - 1, minutes: 59, seconds: 59 };
                    }
                    return { hours, minutes: minutes - 1, seconds: 59 };
                }

                return { hours, minutes, seconds: seconds - 1 };
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [time]);

    const format = (unit) => String(unit).padStart(2, '0');

    const HandleRemovePhoto = (index, id) => {
        if (id === 1) {
            const Copy = [...addDocument];
            Copy.splice(index, 1);
            setAddDocument(Copy);
        } else {
            const AppointmentId = sessionStorage.getItem("Appintmentid");
            if (!Userid && !AppointmentId) return;

            const Data = {
                id: Userid,
                appointment_id: AppointmentId,
                fam_mem_id: String(isPatientBox.id),
                removed_image: getDocument[index]?.img
            };

            axios.post(`${ApiBaseUrl}/customer/remove_pati_heal_image`, Data)
                .then((res) => {
                    // console.log("remove_pati_heal_image", res);
                    const { ResponseCode, message } = res.data;
                    if (ResponseCode === 200) {
                        const Copy = [...getDocument];
                        Copy.splice(index, 1);
                        setGetDocument(Copy);
                        showToast({ title: message, id: "success" });
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

        }
    };

    const handleFileSelect = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            const fileSizeInBytes = file.size;
            const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(0);
            if (fileSizeInMB > "20") {
                showToast({ title: `${file.name} larger than 20MB`, id: "error" });
            } else {
                setAddDocument(prev => [...prev, { type: "doc", img: file }]);
            }
        }
        e.target.value = null;
    };

    const HandleSubmitDetails = () => {
        const AppointmentId = sessionStorage.getItem("Appintmentid");


        if (Userid && AppointmentId) {
            const formData = new FormData();

            formData.append("id", Userid);
            formData.append("appointment_id", AppointmentId);
            formData.append("fam_mem_id", isPatientBox?.id);
            formData.append("health_concern", healthConcern);

            addDocument.forEach((item) => {
                formData.append("document", item.img);
            });

            axios.post(`${ApiBaseUrl}/customer/add_patient_health_concerns`, formData)
                .then((res) => {
                    // console.log("add_patient_health_concerns", res);
                    if (res.data.ResponseCode === 200) {
                        showToast({ title: res.data.message, id: "success" });
                        setIsPatientBox("");
                        setAddDocument([]);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const HandleHealthConcerns = (item) => {
        const AppointmentId = sessionStorage.getItem("Appintmentid");

        if (Userid && AppointmentId) {

            axios.post(`${ApiBaseUrl}/customer/patient_health_concerns`, { id: Userid, appointment_id: AppointmentId, fam_mem_id: String(item.id) })
                .then((res) => {
                    // console.log("patient_health_concerns", res);
                    const { ResponseCode, document, health_concern } = res.data;
                    if (ResponseCode === 200) {
                        setHealthConcern(health_concern);
                        const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];
                        const Doc = [];
                        document.find(item => {
                            const extension = item.split('.')[1];
                            if (imageExtensions.includes(extension)) {
                                Doc.push({ type: "img", img: item });
                            } else {
                                Doc.push({ type: "doc", img: item });
                            }
                        });
                        setGetDocument(Doc);
                        setIsPatientBox(item);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const HandleNavigateMap = (laat, long) => {
        const lat = Number(laat);
        const lng = Number(long);
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
        window.open(googleMapsUrl, '_blank');
    };

    const HandleShowPdf = () => {

        if (isShowDownload) {
            showToast({ title: t("Doctor hasn't uploaded your details. Please contact them to update your info."), id: "warning" });
            return;
        }

        const AppointmentId = sessionStorage.getItem("Appintmentid");
        setIsLoading(true);
        if (selectPatient && Userid) {
            axios.post(`${ApiBaseUrl}/customer/generate_patient_pdf`, { id: Userid, appointment_id: AppointmentId, family_mem_id: String(selectPatient) })
                .then((res) => {
                    // console.log(res);
                    if (res.data.ResponseCode === 200) {
                        setIsLoading(false);
                        const Pdflink = ImgBaseUrl + res.data.pdf_URL;
                        window.open(Pdflink, '_blank');
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const HandleNotification = () => {

        showToast({ title: "For the demo version, the video call feature is disabled.", id: "info" });

        // if (Userid) {
        //     setNotificationLod(true);
        //     axios.post(`${ApiBaseUrl}/customer/send_doctor_notified`, { id: Userid, doctor_id: doctorData?.id })
        //         .then((res) => {
        //             // console.log(res);
        //             if (res.data.ResponseCode === 200) {
        //                 showToast({ title: res.data.message, id: "success" });
        //             }
        //             setNotificationLod(false);
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //         });
        // }
    };

    const HandleVitalaInfo = (Api, parameter, setState, index, id) => {

        const AppointmentId = sessionStorage.getItem("Appintmentid");

        if (!prescriptionload && selectPatient && Userid) {
            setPrescriptionLod(id);

            axios.post(ApiBaseUrl + Api, { id: Userid, appointment_id: AppointmentId, patient_id: String(selectPatient) })
                .then((res) => {
                    // console.log(res.data);
                    setState(res.data[parameter]);
                    const data = res.data[parameter];
                    if (data.length <= 0) {
                        showToast({ title: index, id: "error" });
                    }
                    setPrescriptionLod("");
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const HandleCancelAppointment = () => {

        if (!selectReason) {
            showToast({ title: t("Select Cancel Reason"), id: "error" });
            return;
        }

        if (selectReason === 4 && !otherReason) {
            showToast({ title: t("Enter Other Reason"), id: "error" });
            return;
        }

        const AppointmentId = sessionStorage.getItem("Appintmentid");
        if (Userid) {
            const Data = {
                id: Userid,
                appointment_id: AppointmentId,
                reason_id: selectReason,
                reason: otherReason ? otherReason : ""
            };

            axios.post(`${ApiBaseUrl}/customer/cancel_appointment`, Data)
                .then((res) => {
                    if (res.data.ResponseCode === 200) {
                        showToast({ title: res.data.message, id: "success" });
                        setIsCancelBox(false);
                    }

                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const HandleChat = (Docid) => {
        setShowChat(true);
        setSelectDoc(Docid);
    };

    const AudioCallHandler = async (code, phone) => {
        try {
            const deviceList = await navigator.mediaDevices.enumerateDevices();
            let hasMicrophone = false;

            deviceList.forEach(device => {
                if (device.kind === 'audioinput') {
                    hasMicrophone = true;
                }
            });

            if (!hasMicrophone) {
                setDeviceCheck(true);
                return;
            }

        } catch (error) {
            console.error('Error checking devices:', error);
        }
        window.location.href = `tel:${code + phone}`;
    };

    const HandleAddReview = () => {
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/add_appint_review`, { id: Userid, appointment_id: appointData.id, review: reviewText || "", tot_star: reviewIndex })
                .then((res) => {
                    // console.log("/customer/add_appint_review", res);
                    if (res.data.ResponseCode === 200) {
                        setIsReview(false);
                        showToast({ title: res.data.message, id: "success" });
                        HandleFatchData();
                    }
                })
                .catch((errro) => {
                    console.error("/customer/add_appint_review", errro);
                });
        }
    };

    const HandleAppointCheckList = (id) => {
        setSelectPatient(id);
        setIsLoading(true);
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/check_doc_appoint_upload`, { id: Userid, appointment_id: appointData?.id, fid: id })
                .then((res) => {
                    // console.log("check_doc_appoint_upload", res);
                    setIsLoading(false);
                    const { diagnosis_test, drugs_prescription, vitals_physical } = res.data;
                    setCheckList({ vitals_physical, drugs_prescription, diagnosis_test });
                    if (vitals_physical !== 0 || drugs_prescription !== 0 || diagnosis_test !== 0) {
                        setIsShowDownload(false);
                    } else {
                        setIsShowDownload(true);
                    }
                })
                .catch((error) => {
                    console.error("check_doc_appoint_upload", error);
                });
        }
    };

    return (
        <div className='w-full width-container content-wrapper'>
            {loading
                ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
                : <div className="my-booking">
                    <div className="flex flex-wrap items-start justify-center gap-[20px] mb-[10px]">

                        <div className="width-box">

                            <div className="section-1">
                                <ImageLoad src={ImgBaseUrl + doctorData?.logo} CustomeStyle={"w-[100%] h-[250px] object-cover  rounded-t-[10px]"} alt={"logo"} />
                                <div className="flex justify-center">
                                    <div className="">
                                        <h1 className='font-[500] text-[18px] text-center'>{doctorData?.name}</h1>
                                        <p className='font-[500] text-[15px] text-center'>{sebserviceData?.department_name}</p>
                                        <div className="flex items-center justify-center gap-[20px] mt-[10px]">
                                            <button onClick={(e) => AudioCallHandler(doctorData?.country_code, doctorData?.phone)} className="text-center">
                                                <div className="border-[1px] border-[#8080803b] p-[8px] rounded-[50px] inline-block">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21 19V17.3541C21 16.5363 20.5021 15.8008 19.7428 15.4971L17.7086 14.6835C16.7429 14.2971 15.6422 14.7156 15.177 15.646L15 16C15 16 12.5 15.5 10.5 13.5C8.5 11.5 8 9 8 9L8.35402 8.82299C9.28438 8.35781 9.70285 7.25714 9.31654 6.29136L8.50289 4.25722C8.19916 3.4979 7.46374 3 6.64593 3H5C3.89543 3 3 3.89543 3 5C3 13.8366 10.1634 21 19 21C20.1046 21 21 20.1046 21 19Z" stroke="#28303F" strokeWidth="1.5" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                                <h1 className='-mt-[5px] font-[500]'>{t("Call")}</h1>
                                            </button>
                                            <button onClick={() => HandleChat(doctorData?.id)} className="text-center">
                                                <div className="border-[1px] border-[#8080803b] p-[8px] rounded-[50px] inline-block">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8 10H16M8 14H12M11 3H13C17.9706 3 22 7.02944 22 12C22 16.9706 17.9706 21 13 21H6C3.79086 21 2 19.2091 2 17V12C2 7.02944 6.02944 3 11 3Z" stroke="#28303F" strokeWidth="1.5" strokeLinecap="round" />
                                                    </svg>
                                                </div>
                                                <h1 className='-mt-[5px] font-[500]'>{t("Message")}</h1>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section-2 mt-[10px]">
                                <h1 className='title'>{t("About Appointment")}</h1>
                                <div className="flex items-center justify-between">
                                    <div className="">
                                        <h1 className='font-[500]'>{sebserviceData?.sub_title}</h1>
                                        <div className="text-gray-500 font-[500] flex items-center gap-[10px] mt-[5px]">
                                            <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#808080" strokeWidth="1.5" />
                                                <path d="M3 9H21" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" />
                                                <path d="M8 2L8 5" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M16 2V5" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <circle cx="12" cy="15" r="1" fill="#808080" />
                                                <circle cx="16" cy="15" r="1" fill="#808080" />
                                                <circle cx="8" cy="15" r="1" fill="#808080" />
                                            </svg>
                                            <h1 className='text-[14px]'>{appointData?.appointment_date}, {appointData?.appointment_time}</h1>
                                        </div>
                                    </div>
                                    <ImageLoad src={ImgBaseUrl + sebserviceData?.image} CustomeStyle={"w-[70px] h-[70px] rounded-[10px] object-contain bg-blue-200"} alt={"logo"} />
                                </div>
                                <div className="section-2 mt-[10px]">
                                    <div className="flex items-center gap-[10px]">
                                        <div className="bg-gray-300 p-[10px] rounded-[5px]">
                                            {appointData?.show_type === "1"
                                                ? <img src={Hospital} alt="" />
                                                : <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" fill="black" />
                                                </svg>}
                                        </div>
                                        <div className="leading-[16px]">
                                            <h1 className='font-[500] text-[17px]'>{hospitalData?.name}</h1>
                                            <h1 className='font-[500] text-gray-600 mt-[5px]'>{appointData?.show_type === "1" ? t("In Person Appointment") : t("In Video Appointment")}</h1>
                                            <div className="font-[500] flex items-center gap-[10px] mt-[5px]">
                                                <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#28303F" strokeWidth="1.5" /><path d="M3 9H21" stroke="#28303F" strokeWidth="1.5" strokeLinecap="round" /><path d="M8 2L8 5" stroke="#28303F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 2V5" stroke="#28303F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><circle cx="12" cy="15" r="1" fill="#28303F" /><circle cx="16" cy="15" r="1" fill="#28303F" /><circle cx="8" cy="15" r="1" fill="#28303F" /></svg>
                                                <h1 className='text-[14px]'>{appointData?.appointment_date}, {appointData?.appointment_time}</h1>
                                            </div>
                                        </div>
                                    </div>

                                    {(Data?.status === 0 && appointData?.show_type === "2") && <div className="">
                                        {(time.hours || time.minutes || time.seconds)
                                            ? <div className="text-center w-[100%] border-[2px] border-[#8080803b] rounded-[50px] py-[5px] mt-[10px]">
                                                <h1 className='font-[500]'>Join video Call - <span className='text-[#4038FF]'>{format(time.hours)}:{format(time.minutes)}:{format(time.seconds)}</span> left</h1>
                                            </div>
                                            : Data?.status === 0 && <button onClick={HandleNotification} style={{ fontSize: "16px" }} className='payment-btn mt-[10px]'>
                                                {notificationlod
                                                    ? <div className="loader mx-auto"></div>
                                                    : <span>{t("Send Notification")}</span>}
                                            </button>}
                                    </div>}
                                </div>
                            </div>

                            {Data?.status === 0 && <div className="section-1 mt-[10px]">
                                <h1 className='title'>{t("Patient Info")}</h1>
                                <div className="patient-list">
                                    <div className="slider-container mt-[10px]">
                                        <Slider {...settings}>
                                            {familyData.map((item, index) => {
                                                return <div onClick={() => HandleHealthConcerns(item)} key={index} className="patient-box text-center cursor-pointer relative overflow-visible">
                                                    <div className="patient-img border-[3px] border-[#8080803b]">
                                                        <ImageLoad src={ImgBaseUrl + item.profile_image} CustomeStyle={"w-full h-full rounded-[100%] object-cover"} alt={"profile_image"} />
                                                    </div>
                                                    <h1 className="font-[500] text-[16px] text-gray-400 whitespace-nowrap overflow-hidden overflow-ellipsis">{item.name}</h1>
                                                    <span className='text-[14px] bg-[#4038FF] text-white rounded-[50px] py-[2px] px-[10px]'>{t("Upload")}</span>
                                                </div>
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                            </div>}

                            {token && <div className="section-1 mt-[10px]">
                                <div className="flex items-center gap-4 mb-2">
                                    <span className='w-full border'></span>
                                    <h1 className='font-bold text-[18px] whitespace-nowrap'>{t("Your Token")}</h1>
                                    <span className='w-full border'></span>
                                </div>
                                <div className="border-y-[2px] border-dashed py-[8px]">
                                    <h1 className='font-bold text-center text-[20px] text-[#4038FF]'># {token?.my_queue_token}</h1>
                                </div>
                                <div className="py-[8px] flex items-center gap-1 justify-center">
                                    <span className='w-[10px] h-[10px] bg-green-600 rounded-full'></span>
                                    <span>{t("Waiting")}</span>
                                </div>
                                <div className="border-t-[2px] border-dashed pt-[8px]">
                                    <div className="flex items-stretch justify-center gap-4">
                                        <div>
                                            <h1 className='font-bold'>{t("Now Serving")}</h1>
                                            <div className="bg-green-600 text-center font-medium text-white rounded-[5px] mt-1 py-[3px]">
                                                # {token?.running_queue}
                                            </div>
                                        </div>
                                        <div className="w-[2px] h-[initial] bg-gray-300"></div>
                                        <div className="text-center">
                                            <h1 className='font-bold'>{t("Ahead fo You")}</h1>
                                            <p className='font-bold py-[3px]'>{token?.patients_ahead}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                            {appointData?.status === "5" && <div className="section-3 mt-[10px]">
                                <h1 className='title'>{t("Appointment Cancel")}</h1>
                                <p className='font-[500] text-gray-400'>{t("Cancel")} : <span className='text-gray-600'>{appointData?.cancel_reason || appointData?.cancel_title}</span> </p>
                            </div>}


                        </div>

                        <div className="width-box">

                            {Data?.status === 0 && <div className="section-1">
                                <div className="">
                                    <h1 className='title'>{t("OTP Info")}</h1>
                                    <h1 className='font-[500] text-gray-400'>{appointData?.status === "1" ? t("Start OTP") : t("End OTP")} : <span className='text-[#4038FF]'>{appointData?.otp}</span></h1>
                                </div>
                                <div className="mt-[5px]">
                                    <h1 className='title'>{t("QR Code")}</h1>
                                    <img src={appointData?.qrcode} className='mx-auto' alt="" />
                                </div>
                            </div>}

                            <div className={`section-1 ${Data?.status === 0 && "mt-[10px]"}`}>
                                <h1 className='title'>{t("Appointment Checklists")}</h1>
                                <div className="patient-list">
                                    <div className="slider-container mt-[10px]">
                                        <Slider {...settings}>
                                            {familyData.map((item, index) => {
                                                return <div key={index} onClick={() => HandleAppointCheckList(item.id)} className="patient-box text-center cursor-pointer relative overflow-visible">
                                                    <div className={`patient-img  ${selectPatient === item.id ? "border-[#4038FF]" : "border-[#8080803b]"} border-[2px]`}>
                                                        <ImageLoad src={ImgBaseUrl + item.profile_image} CustomeStyle={"w-full h-full rounded-[100%] object-cover"} alt={"patient"} />
                                                    </div>
                                                    <h1 className={`font-[500] text-[16px] ${selectPatient === item.id ? "text-[#4038FF]" : "text-gray-400"} whitespace-nowrap overflow-hidden overflow-ellipsis`}>{item.name}</h1>
                                                </div>
                                            })}
                                        </Slider>
                                    </div>
                                </div>

                                <div className="section-2">
                                    <button onClick={() => HandleVitalaInfo("/customer/appoi_vit_phy_list", "vit_phy_list", setVitalaInfoData, "No Vitala & Physical placed !!", 1)} disabled={checkList?.vitals_physical === 0 ? true : false} style={{ cursor: checkList?.vitals_physical === 0 && "default" }} className="flex items-center justify-between w-[100%]">
                                        <div className="flex items-center gap-[10px]">
                                            <IoCheckmarkCircle className={`text-[25px] ${checkList?.vitals_physical === 0 ? "text-gray-400" : "text-green-500"}`} />
                                            <div className="leading-[18px] text-start">
                                                <h1 className='font-[500] text-[16px]'>{t("Vital & Physical information")}</h1>
                                                <p className='text-gray-400 font-[500] text-[14px]'>{t("Physical examination details")}</p>
                                            </div>
                                        </div>
                                        {prescriptionload === 1
                                            ? <div className="loader2"></div>
                                            : <MdOutlineArrowCircleRight className='text-[25px] text-gray-400' />}
                                    </button>
                                    <button onClick={() => HandleVitalaInfo("/customer/appo_dru_pres_list", "drug_presciption", setDrugsInfoData, "No Drugs & Precription placed !!", 2)} disabled={checkList?.drugs_prescription === 0 ? true : false} style={{ cursor: checkList?.drugs_prescription === 0 && "default" }} className="flex items-center justify-between w-[100%] py-[12px]">
                                        <div className="flex items-center gap-[10px]">
                                            <IoCheckmarkCircle className={`text-[25px] ${checkList?.drugs_prescription === 0 ? "text-gray-400" : "text-green-500"}`} />
                                            <div className="leading-[18px] text-start">
                                                <h1 className='font-[500] text-[16px]'>{t("Drugs & Prescription info")}</h1>
                                                <p className='text-gray-400 font-[500] text-[14px]'>{t("Medications prescription and dosage instructions")}</p>
                                            </div>
                                        </div>
                                        {prescriptionload === 2
                                            ? <div className="loader2"></div>
                                            : <MdOutlineArrowCircleRight className='text-[25px] text-gray-400' />}
                                    </button>
                                    <button onClick={() => HandleVitalaInfo("/customer/appo_diagnosis_list", "appoint", setDiagnosisData, "No Diagnosis placed !!", 3)} disabled={checkList?.diagnosis_test === 0 ? true : false} style={{ cursor: checkList?.diagnosis_test === 0 && "default" }} className="flex items-center justify-between w-[100%]">
                                        <div className="flex items-center gap-[10px]">
                                            <IoCheckmarkCircle className={`text-[25px] ${checkList?.diagnosis_test === 0 ? "text-gray-400" : "text-green-500"}`} />
                                            <div className="leading-[18px] text-start">
                                                <h1 className='font-[500] text-[16px]'>{t("Diagnosis Tests")}</h1>
                                                <p className='text-gray-400 font-[500] text-[14px]'>{t("Medical tests and diagnostic evaluations")}</p>
                                            </div>
                                        </div>
                                        {prescriptionload === 3
                                            ? <div className="loader2"></div>
                                            : <MdOutlineArrowCircleRight className='text-[25px] text-gray-400' />}
                                    </button>
                                </div>


                                <button onClick={HandleShowPdf} className={`w-[100%] ${isLoading ? "bg-[#0000ff5e]" : isShowDownload ? "bg-gray-400" : "bg-[#4038FF]"} font-[500] text-white py-[6px] rounded-[50px] mt-[10px]`}>
                                    {isLoading
                                        ? <div className="loader mx-auto"></div>
                                        : <h1>{t("Download Prescription")}</h1>
                                    }
                                </button>
                            </div>

                            <div className="section-3 mt-[10px]">
                                <h1 className='title'>{t("Booking Date & Time Info")}</h1>
                                <p className='font-[500] text-gray-400'>{t("Booking")} : <span className='text-gray-600'>{appointData?.book_date}</span> </p>
                            </div>

                            <div className="section-4 mt-[10px]">
                                <h1 className='title'>{t("Bill Summary")}</h1>
                                <h1 className='font-[500] text-gray-400'>{t("Doctor Consultation Charge")} : <span className='text-gray-600'>$ {appointData?.show_type_price}.0</span> </h1>
                                {appointData?.additional_price !== 0 && <h1 className='font-[500] text-gray-400'>{t("Additional Price")} : <span className='text-gray-600'>$ {appointData?.additional_price}</span> </h1>}
                                <div className='flex items-center gap-[5px] relative text-gray-400 font-[500]'>
                                    <span>{t("Service Fee & Tax")} : </span>
                                    <div className="tooltip">
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle cx="12" cy="17" r="1" fill="#28303F" />
                                            <path
                                                d="M12 14L12 7M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                                                stroke="#28303F"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        <div className="tooltiptext">
                                            <p className="text-white">
                                                {t("Service Fee & Tax")} : $ {appointData?.site_commisiion}
                                            </p>
                                            <p className="text-white">
                                                {t("Doctor Commission")} : $ {appointData?.doctor_commission}
                                            </p>
                                        </div>
                                    </div>
                                    <span className="text-gray-600">
                                        $ {appointData?.site_commisiion + appointData?.doctor_commission}
                                    </span>
                                </div>

                                {appointData?.coupon_amount !== 0 && <h1 className='font-[500] text-gray-400'>{t("Coupon Amount")} : <span className='text-gray-600'>$ -{appointData?.coupon_amount}.0</span> </h1>}
                                {appointData?.wallet_amount !== 0 && <h1 className='font-[500] text-gray-400'>{t("Wallet Amount")} : <span className='text-gray-600'>$ {appointData?.wallet_amount}</span> </h1>}
                                {(appointData?.payment_name !== "Cash" && appointData?.payment_name) && (
                                    <h1 className='font-[500] text-gray-400'>
                                        {t("Payment")} <span className='text-gray-600'>({appointData?.payment_name})</span> :
                                        <span className='text-gray-600'> $ {appointData?.online_amount}</span>
                                    </h1>
                                )}
                                <h1 className='font-[500] text-gray-400'>{t("Total Price")} : <span className='text-gray-600'>$ {appointData?.tot_price}</span> </h1>
                                <h1 className='font-[500] text-gray-400'>{t("TransactionId")} : <span className='text-gray-600'>{appointData?.transactionId}</span> </h1>
                            </div>

                        </div>
                    </div>

                    <div className="map-box section-1">
                        <h1 className='font-[500] text-[18px]'>{t("Hospital Address")}</h1>
                        <div className="Map mt-[5px] relative">
                            {isLoaded && <GoogleMap
                                center={{ lat: Number(hospitalData?.latitude), lng: Number(hospitalData?.longitude) }}
                                zoom={17}
                                options={{
                                    draggable: false,
                                    scrollwheel: false,
                                    disableDoubleClickZoom: true,
                                    keyboardShortcuts: false
                                }}

                                onClick={() => HandleNavigateMap(hospitalData?.latitude, hospitalData?.longitude)}
                            >
                                <Marker icon={{
                                    url: MapPin,
                                    scaledSize: new window.google.maps.Size(25, 25),
                                }}
                                    position={{
                                        lat: Number(hospitalData?.latitude),
                                        lng: Number(hospitalData?.longitude),
                                    }}
                                />
                            </GoogleMap>}

                            <div onClick={() => HandleNavigateMap(hospitalData?.latitude, hospitalData?.longitude)} className="w-[100%] absolute bottom-[5px] px-[10px] cursor-pointer">
                                <div className="bg-white p-[8px] rounded-[10px]">
                                    <div className="flex items-center gap-[10px]">
                                        <div className="bg-[#4038ff33] p-[8px] rounded-[5px]">
                                            <TbMapPinFilled className='text-[25px] text-[blue]' />
                                        </div>
                                        <h1 className='font-[500] text-[15px]'>{hospitalData?.address}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {appointData?.status === "1" && <div className="flex justify-center mt-[20px]">
                        <button onClick={() => setIsCancelBox(true)} className='bg-red-400 hover:bg-red-500 min-w-[200px] py-[6px] font-[500] text-white rounded-[10px]'>{t("Cancel")}</button>
                    </div>}

                    {(appointData?.status === "4" && appointData?.review_check === 0) && <div className="flex justify-center mt-[20px]">
                        <button onClick={() => setIsReview(true)} className='bg-[#4038FF] hover:bg-[#3f38ffce] min-w-[200px] py-[6px] font-[500] text-white rounded-[10px]'>{t("Review")}</button>
                    </div>}

                </div>}


            {isPatientBox && <div onClick={() => setIsPatientBox("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bottme-box">
                    <div className="flex items-center gap-[10px] border-b-[1px] border-[#8080803b] pb-[5px]">
                        <button onClick={() => setIsPatientBox("")}><IoChevronBackOutline className='text-[20px]' /></button>
                        <div className="leading-[20px]">
                            <h1 className='font-[500] text-[17px]'>{t("Share Health Concerns")}</h1>
                            <p className='font-[500] text-[16px] text-gray-400'>{t("With")} <span className='text-[#4038FF]'>{doctorData?.name}</span> {t("prior to your consultation")}</p>
                        </div>
                    </div>
                    <div className="mt-[10px] flex items-center gap-[10px]">
                        <ImageLoad src={ImgBaseUrl + isPatientBox?.profile_image} CustomeStyle={"w-[70px] h-[70px] object-cover rounded-[10px]"} alt={"profile_image"} />
                        <div className="">
                            <h1 className='font-[500] text-[18px]'>{isPatientBox?.name}</h1>
                            <h1 className='font-[500]'>{isPatientBox?.gender}, {isPatientBox?.patient_age} Yrs</h1>
                        </div>
                    </div>
                    <div className="mt-[10px]">
                        <h1 className='font-[500] text-[18px]'>{t("Health Concerns")}</h1>
                        <input value={healthConcern} onChange={(e) => setHealthConcern(e.target.value)} type="text" className='border-[1px] border-[#8080803b] w-[100%] rounded-[5px] py-[8px] px-[10px] focus-within:outline-[#4038FF]' placeholder={t('Enter Disease')} />
                    </div>
                    <div className="mt-[10px]">
                        <h1 className='font-[500] text-[17px]'>{t("Add Health Documents")}</h1>
                        <p className='font-[500] text-gray-400 text-[15px]'>{t("E.g. Past Prescription, Test Report, Photo, etc.")}</p>
                        <p className='font-[500] text-gray-400 text-[15px]'>{t("Maximum File Upload Size")}: <span className='text-black'>20 MB</span>/ {t("Document")}</p>
                        <div className="flex items-center gap-[10px] mt-[10px]">
                            <button onClick={() => InputRef.current.click()} style={{ fontSize: "16px" }} className='payment-btn'>{t("Add Photo")}</button>
                            <button onClick={() => InputRef2.current.click()} style={{ fontSize: "16px" }} className='payment-btn'>{t("Add Document")}</button>
                            <input
                                ref={InputRef}
                                onChange={(e) => {
                                    if (e.target.files && e.target.files[0]) {
                                        const file = e.target.files[0];
                                        setAddDocument(prev => [...prev, { type: "img", img: file }]);
                                    }
                                    e.target.value = null;
                                }}
                                accept="image/*"
                                type="file"
                                className='hidden'
                            />

                            <input ref={InputRef2}
                                className="hidden" type="file" name="light_image"
                                accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.ppt,.pptx"
                                onChange={handleFileSelect}
                            />
                        </div>
                        <div className="slider-container">
                            <Slider {...settings2}>
                                {getDocument.map((item, index) => {
                                    const image = item.type === "img" ? (ImgBaseUrl + item.img) : "./assets/Icon/Doc.svg";
                                    return (
                                        <div key={index} className="relative mt-[20px]">
                                            <ImageLoad src={image} CustomeStyle={`w-[100%] max-h-[150px] min-h-[150px]  ${item.type === "img" ? "object-cover" : "object-contain"} rounded-[10px]`} alt={`Uploaded ${index}`} />
                                            <button
                                                onClick={() => HandleRemovePhoto(index, 2)}
                                                className="absolute top-[3px] right-[3px] bg-red-500 rounded-[50px] p-[1px]"
                                            >
                                                <IoCloseSharp className='text-[20px] text-white' />
                                            </button>
                                        </div>
                                    );
                                })}
                                {addDocument.map((item, index) => {

                                    const image = item.type === "img"
                                        ? URL.createObjectURL(item.img)
                                        : "./assets/Icon/Doc.svg";

                                    return (
                                        <div key={index} className="relative mt-[20px]">
                                            <ImageLoad src={image} CustomeStyle={`w-[100%] max-h-[150px] min-h-[150px]  ${item.type === "img" ? "object-cover" : "object-contain"} rounded-[10px]`} alt={`Uploaded ${index}`} />
                                            <button
                                                onClick={() => HandleRemovePhoto(index, 1)}
                                                className="absolute top-[3px] right-[3px] bg-red-500 rounded-[50px] p-[1px]"
                                            >
                                                <IoCloseSharp className='text-[20px] text-white' />
                                            </button>
                                        </div>
                                    );
                                })}

                            </Slider>
                        </div>
                    </div>
                    <button onClick={HandleSubmitDetails} className='w-[100%] bg-[#4038FF] text-white mt-[20px] py-[7px] rounded-[10px] font-[500]'>{t("Submit Details")}</button>
                </div>
            </div>}

            {vitalaInfoData.length > 0 && (<div onClick={() => setVitalaInfoData("")} className="fixed top-0 left-0 z-[999] w-full h-full bg-[#00000069] flex justify-center items-end" >
                <div onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container bg-white p-4 rounded-t-[10px]" >
                    <h1 className="text-center text-[18px] font-medium">{t("Virtual and Physical")}</h1>

                    <div>
                        {vitalaInfoData.map((item, index) => (
                            <div key={index} className="py-[5px]">
                                <h2 className="text-[17px] font-medium">{item.title}</h2>
                                <div className="mt-[5px] rounded-[10px] border border-[#8080803b] px-[10px] py-[5px]">
                                    <span>{item.text}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            )}

            {drugsInfoData.length > 0 && <div onClick={() => setDrugsInfoData("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container">
                    <h1 className='font-[500] text-center text-[18px] mb-[5px]'>{t("Medicine")}</h1>
                    <div className="">
                        {drugsInfoData.map((item, index) => {
                            return <div key={index} className="border-[1px] border-[#8080803b] p-[10px] rounded-[10px] mb-[8px]">
                                <div className="flex items-center justify-between">
                                    <h1 className='font-[500] text-[17px]'>{item.medicine_name} {item.type}</h1>
                                    <img src={capsule} alt="capsule" />
                                </div>
                                <span className='text-gray-400'>1 Spoon | {item.Dosage} | {item.Days}</span>
                                <div className="flex items-center justify-between mt-[5px]">
                                    <h1 className='bg-[#ff000045] text-[red] text-[14px] font-[500] py-[3px] px-[8px] rounded-[5px]'>{item.Time}</h1>
                                    <h1 className='text-gray-400'>{item.Frequency}</h1>
                                    <button onClick={() => setMedicineDetails(item)} className='text-[#4038FF] font-[500] text-[15px]'>View Details</button>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>}

            {medicineDetails && <div onClick={() => setMedicineDetails("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container">
                    <h1 className='font-[500] text-center text-[18px] mb-[5px]'>{t("Information")}</h1>
                    <div className="">
                        <div className="">
                            <span className='text-gray-400 font-[500] text-[16px]'>{t("Medicine Name")}</span>
                            <h1 className='font-[500] text-[18px]'>{medicineDetails?.medicine_name} {medicineDetails?.Dosage}</h1>
                        </div>
                        <div className="border-t-[1px] border-[#8080803b] pb-[10px] mt-[10px]"></div>
                        <div className="">
                            <h1 className='font-[500] text-[18px]'>{t("Time")}</h1>
                            <span className='text-gray-400 font-[500] text-[16px]'>{medicineDetails?.Time}</span>
                        </div>
                        <div className="mt-[5px]">
                            <h1 className='font-[500] text-[18px]'>{t("Dosage")}</h1>
                            <span className='text-gray-400 font-[500] text-[16px]'>{medicineDetails?.Dosage}</span>
                        </div>
                        <div className="mt-[5px]">
                            <h1 className='font-[500] text-[18px]'>{t("Duration")}</h1>
                            <span className='text-gray-400 font-[500] text-[16px]'>{medicineDetails?.Days}</span>
                        </div>
                        <div className="mt-[5px]">
                            <h1 className='font-[500] text-[18px]'>{t("Frequency")}</h1>
                            <span className='text-gray-400 font-[500] text-[16px]'>{medicineDetails?.Frequency}</span>
                        </div>
                        <div className="mt-[5px]">
                            <h1 className='font-[500] text-[18px]'>{t("Instructions")}</h1>
                            <span className='text-gray-400 font-[500] text-[16px]'>{medicineDetails?.Instructions}</span>
                        </div>
                    </div>
                </div>
            </div>}

            {diagnosisData.length > 0 && <div onClick={() => setDiagnosisData("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container">
                    <h1 className='font-[500] text-center text-[18px]'>{t("Diagnosis Test")}</h1>
                    <div className="">
                        {diagnosisData.map((item, index) => {
                            return <div key={index} className="border-[1px] border-[#8080803b] p-[10px] rounded-[10px] mt-[8px]">
                                <div className="flex items-center gap-[10px]">
                                    <div className="bg-blue-200 p-[8px] rounded-[50px]">
                                        <img src={test_tube} alt="test_tube" />
                                    </div>
                                    <div className="leading-[18px]">
                                        <h1 className='font-[500] text-[16px]'>{item.name}</h1>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>}

            {isCancelBox && <div onClick={() => setIsCancelBox(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container">
                    <h1 className='font-bold text-center text-[18px]'>{t("Select Reason")}</h1>
                    <p className='text-center text-[17px]'>{t("Please Select the Reason for Cancellation")} : </p>
                    <div className="px-[10px]">
                        {cancelReasonList.map((item, index) => {
                            return <div onClick={() => setSelectReason(item.id)} key={index} className="py-[5px] cursor-pointer flex items-center">
                                <div className="w-[30px] check-box">
                                    <input id="radio1" className="peer hidden" type="radio" name="group1" />
                                    <div className={`w-5 h-5 rounded-full flex items-center justify-center ${selectReason === item.id ? "box-activeborder" : "box-border"}`}>
                                        <span className={`w-[10px] h-[10px] rounded-full duration-[0.3s] ${selectReason === item.id && "box-activebg"}`}></span>
                                    </div>
                                </div>
                                <h1>{item.title}</h1>
                            </div>
                        })}
                        {selectReason === 4 && <input type="text" onChange={(e) => setOtherReason(e.target.value)} className='border-[1px] focus-within:outline-[#4038FF] border-[#8080803b] w-[100%] py-[8px] px-[10px] rounded-[10px]' placeholder='Enter reason' />}
                    </div>
                    <div className="flex items-center gap-[20px] mt-[10px]">
                        <button onClick={() => setIsCancelBox(false)} className='w-[100%] bg-red-400 hover:bg-red-500 py-[6px] font-[500] text-white rounded-[50px]'>{t("Cancel")}</button>
                        <button onClick={HandleCancelAppointment} className='w-[100%] bg-[#000000c2] hover:bg-black py-[6px] font-[500] text-white rounded-[50px]'>{t("Confirm")}</button>
                    </div>
                </div>
            </div>}

            {showChat && <div onClick={() => setShowChat(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="chat_bottom">
                    <Chat index={1} setShowChat={setShowChat} doctorId={selectDoc} />
                </div>
            </div>}

            {deviceCheck && <div onClick={() => setDeviceCheck(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-[15px] p-4">
                    <h6 className='m-0 font-[500] text-[18px] text-gray-600'>{t("Required for voice and video calls. Make")} <br /> {t("sure your audio device (headset, speakers,")}<br /> {t("or microphone) is connected and working.")}</h6>
                </div>
            </div>}

            {isReview && <div onClick={() => setIsReview(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="chat_bottom">
                    <h1 className='font-[500] text-[20px] text-center pb-[20px]'>{t("Leave a Review")}</h1>
                    <div className="border-y-[1px] border-[#8080803b] py-[15px]">
                        <h1 className='font-[500] text-[18px] text-center'>{t("How was your experience")}</h1>
                        <div className="flex items-center justify-center gap-[10px] mt-[10px]">
                            {[1, 2, 3, 4, 5].map((index) => {
                                return <div onClick={() => setReviewIndex(index)} key={index} className="cursor-pointer">
                                    <svg width="26" height="26" viewBox="0 0 24 24" fill={reviewIndex >= index ? "#4038FF" : "none"} xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.0328 3.27141C10.8375 1.5762 13.1625 1.57619 13.9672 3.27141L15.3579 6.20118C15.6774 6.87435 16.2951 7.34094 17.0096 7.44888L20.1193 7.91869C21.9187 8.19053 22.6371 10.4895 21.3351 11.8091L19.0849 14.0896C18.5679 14.6136 18.332 15.3685 18.454 16.1084L18.9852 19.3285C19.2926 21.1918 17.4116 22.6126 15.8022 21.7329L13.0208 20.2126C12.3817 19.8633 11.6183 19.8633 10.9792 20.2126L8.19776 21.7329C6.58839 22.6126 4.70742 21.1918 5.01479 19.3286L5.54599 16.1084C5.66804 15.3685 5.43211 14.6136 4.91508 14.0896L2.66488 11.8091C1.36287 10.4895 2.08133 8.19053 3.88066 7.91869L6.99037 7.44888C7.70489 7.34094 8.32257 6.87435 8.64211 6.20118L10.0328 3.27141Z" stroke="#4038FF" strokeWidth="1.5" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className="py-[15px]">
                        <h1 className='font-[500] text-[18px] text-center mb-[10px]'>{t("Write Your Rewiew")}</h1>
                        <textarea onChange={(e) => setReviewText(e.target.value)} className='w-[100%] min-h-[100px] max-h-[100px] px-[10px] py-[5px] focus-within:outline-[#4038FF] border-[2px] bprder-[#8080803b] rounded-[10px]' placeholder={t('Your reviewe here..')} />
                    </div>
                    <div className="border-t-[1px] border-[#8080803b] py-[10px] flex items-center justify-center gap-[20px]">
                        <button onClick={() => setIsReview(false)} className='w-[30%] bg-[#3f38ff3b] text-[blue] font-[500] py-[8px] rounded-[50px]'>{t("Maybe Later")}</button>
                        <button onClick={HandleAddReview} className='w-[30%] bg-[#4038FF] text-white font-[500] py-[8px] rounded-[50px]'>{t("Submit")}</button>
                    </div>
                </div>
            </div>}

        </div >
    )
}

export default BookingDetails